import React, { useState } from "react";
import axios from "axios";

const DoctorLogin = ({ onLogin = () => {} }) => {  // Default no-op function
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(
        "https://ricgop.online/api/doctor_login.php",
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.status === "success") {
        onLogin(res.data.doctor);  // safe to call now
      } else {
        setError(res.data.message || "Login failed");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Login failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="login-container" role="main" aria-labelledby="login-title">
        <div className="floating-circles" aria-hidden="true">
          <span className="circle c1"></span>
          <span className="circle c2"></span>
          <span className="circle c3"></span>
          <span className="circle c4"></span>
        </div>

        <section className="login-card" aria-label="Doctor login form">
          <div className="logo" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3f51b5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-plus"
            >
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
          </div>

          <h1 id="login-title" className="login-title">
            Doctor Login
          </h1>

          {error && (
            <p className="message error" role="alert" aria-live="assertive">
              {error}
            </p>
          )}

          <form className="login-form" onSubmit={handleSubmit} noValidate>
            <label htmlFor="email" className="input-label">
              Email
              <input
                id="email"
                name="email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                disabled={loading}
              />
            </label>

            <label htmlFor="password" className="input-label">
              Password
              <input
                id="password"
                name="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                disabled={loading}
              />
            </label>

            <button
              type="submit"
              className="login-btn"
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? <span className="spinner" aria-hidden="true"></span> : "Login"}
            </button>
          </form>

          <p className="login-footer">
            Don't have an account?{" "}
            <a href="/doctor/signup" className="login-link">
              Sign Up
            </a>
          </p>
        </section>
      </main>

      {/* Your existing styles here */}
           <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');

        /* Reset */
        * {
          box-sizing: border-box;
        }
        body {
          margin: 0;
          font-family: 'Poppins', sans-serif;
          background: #e8eaff;
          overflow-x: hidden;
        }

        /* Container and background circles */
        .login-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          position: relative;
          background: linear-gradient(135deg, #e8eaff 0%, #c9d6ff 100%);
        }
        .floating-circles {
          position: absolute;
          inset: 0;
          overflow: hidden;
          z-index: 0;
          pointer-events: none;
        }
        .circle {
          position: absolute;
          background: #3949ab;
          opacity: 0.15;
          border-radius: 50%;
          filter: blur(60px);
          animation: floatUpDown 6s ease-in-out infinite alternate;
        }
        .c1 {
          width: 140px;
          height: 140px;
          bottom: 20%;
          left: 10%;
          animation-delay: 0s;
        }
        .c2 {
          width: 100px;
          height: 100px;
          top: 15%;
          right: 15%;
          animation-delay: 2s;
        }
        .c3 {
          width: 120px;
          height: 120px;
          top: 50%;
          left: 40%;
          animation-delay: 3.5s;
        }
        .c4 {
          width: 80px;
          height: 80px;
          bottom: 10%;
          right: 30%;
          animation-delay: 5s;
        }
        @keyframes floatUpDown {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-25px);
          }
        }

        /* Card */
        .login-card {
          position: relative;
          background: rgba(255 255 255 / 0.85);
          backdrop-filter: blur(12px);
          border-radius: 20px;
          box-shadow: 0 16px 40px rgba(57, 73, 171, 0.25);
          padding: 48px 40px 56px;
          max-width: 420px;
          width: 100%;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          animation: fadeInScale 0.6s ease forwards;
        }
        @keyframes fadeInScale {
          0% {
            opacity: 0;
            transform: scale(0.9);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        /* Logo */
        .logo {
          margin-bottom: 30px;
          transition: transform 0.4s ease;
          cursor: default;
        }
        .logo:hover {
          transform: rotate(15deg);
        }

        /* Title */
        .login-title {
          font-weight: 700;
          font-size: 2.4rem;
          color: #283593;
          margin: 0 0 32px;
          user-select: none;
          text-align: center;
          letter-spacing: 1.2px;
        }

        /* Message */
        .message {
          width: 100%;
          font-size: 1rem;
          padding: 14px 16px;
          border-radius: 12px;
          margin-bottom: 24px;
          text-align: center;
          font-weight: 600;
          user-select: none;
        }
        .message.error {
          background-color: #f8d7da;
          color: #721c24;
          border: 1.5px solid #f5c6cb;
        }

        /* Form labels */
        .input-label {
          width: 100%;
          display: flex;
          flex-direction: column;
          font-weight: 600;
          font-size: 1.05rem;
          color: #3949ab;
          margin-bottom: 22px;
          user-select: none;
        }

        /* Inputs */
        input {
          margin-top: 8px;
          padding: 14px 18px;
          font-size: 1rem;
          border-radius: 12px;
          border: 1.8px solid #b0bec5;
          outline-offset: 3px;
          outline-color: transparent;
          font-family: 'Poppins', sans-serif;
          transition: border-color 0.3s ease, box-shadow 0.3s ease;
          color: #1a237e;
        }
        input::placeholder {
          font-style: italic;
          color: #9fa8da;
        }
        input:focus:not(:disabled) {
          border-color: #3f51b5;
          box-shadow: 0 0 10px #3949abaa;
          outline-color: #3949abcc;
        }
        input:disabled {
          background: #e0e0e0;
          cursor: not-allowed;
        }

        /* Button */
        .login-btn {
          width: 100%;
          padding: 16px 0;
          background: linear-gradient(90deg, #3949ab, #5c6bc0);
          color: white;
          font-size: 1.15rem;
          font-weight: 700;
          border-radius: 14px;
          border: none;
          cursor: pointer;
          box-shadow: 0 8px 25px #3949abbb;
          user-select: none;
          transition: background 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }
        .login-btn:hover:not(:disabled) {
          background: linear-gradient(90deg, #5c6bc0, #3949ab);
          box-shadow: 0 12px 35px #3949abcc;
          transform: translateY(-3px);
        }
        .login-btn:active:not(:disabled) {
          transform: scale(0.98);
          box-shadow: 0 6px 20px #3949abbb;
        }
        .login-btn:disabled {
          background: #9fa8da;
          cursor: not-allowed;
          box-shadow: none;
          transform: none;
        }

        /* Loading spinner */
        .spinner {
          border: 3px solid transparent;
          border-top: 3px solid white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          animation: spin 1s linear infinite;
          display: inline-block;
        }
        @keyframes spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }

        /* Footer */
        .login-footer {
          margin-top: 28px;
          font-weight: 600;
          font-size: 1rem;
          color: #3949abdd;
          user-select: none;
          text-align: center;
        }
        .login-link {
          color: #283593;
          font-weight: 700;
          text-decoration: none;
          transition: color 0.3s ease;
          cursor: pointer;
        }
        .login-link:hover,
        .login-link:focus {
          color: #1a237e;
          text-decoration: underline;
          outline: none;
        }

        /* Responsive */
        @media (max-width: 480px) {
          .login-card {
            padding: 40px 30px 50px;
            border-radius: 24px;
          }
          .login-title {
            font-size: 2rem;
          }
          .input-label {
            font-size: 1rem;
          }
          .login-btn {
            font-size: 1.1rem;
            padding: 14px 0;
          }
        }
      `}</style>
    </>
  );
};

export default DoctorLogin;
